function applyViewProperties(rootView = {}) {
  return (addressForms) => {
    const fieldSettings = rootView.fieldSettings;
    if (fieldSettings) {
      const modifiedFields = addressForms.fields?.map(
        (field) => field.target ? overrideFieldProperties(
          field,
          fieldSettings[field.target]
        ) : field
      );
      return { ...addressForms, fields: modifiedFields };
    } else {
      return addressForms;
    }
  };
}
function overrideFieldProperties(field, settings) {
  if (settings) {
    return {
      ...field,
      hidden: settings.show === void 0 ? field.hidden : !settings.show
    };
  } else {
    return field;
  }
}
export {
  applyViewProperties
};
//# sourceMappingURL=apply-view-properties.js.map
